import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import api from "../Api";
import "./Search.css";

const HOST = window.location.hostname === "localhost" ? "http://localhost:3000" : process.env.PUBLIC_URL;
const CITY_DETAIL_ENDPOINT = HOST + "/detail/";
const MAX_RESULTS = 7;

export function Search() {
    const [input, setInput] = useState("");
    const [results, setResults] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const [focusedIndex, setFocusedIndex] = useState(-1); // -1 means no item is focused
    const [activeSearch, setActiveSearch] = useState(false);

    useEffect(() => {
        if (isSearching) {
            const timer = setTimeout(() => {
                searchCity(input);
            }, 250);

            return () => clearTimeout(timer);
        }
    }, [input, isSearching]);

    const handleChange = (event) => {
        setInput(event.target.value);
        setIsSearching(true);
        setFocusedIndex(-1);
    };

    const searchCity = async (searchString) => {
        const searchResults = [];
        if (!searchString || searchString.trim() === '')  {
            setResults([]);
            return;
        }
        try {
            const citySearchResponse = await api.get(`/rufa/city/search`, {
                params: {
                    searchString: searchString,
                    sort: 'population', // Add this line
                    order: 'desc' // And this line
                }
            });
            for (const i in citySearchResponse.data) {
                searchResults.push(citySearchResponse.data[i]);
            }
            const foundCityName = searchResults.filter(e => e.city_name.toLowerCase().startsWith(searchString.toLowerCase()));
            setResults(foundCityName);
        } catch (error) {
            console.error(error);
        } finally {
            setIsSearching(false);
        }
    };

    useEffect(() => {
                if (results.length > 0 && results.length != null) {
                    if (!activeSearch) {
                        setTimeout(function() { // this timeout is needed or else the backend will not know which city was selected
                            document.getElementById("searchList").style.display = "none";
                        }, 250)
                    } else if (activeSearch) {
                        document.getElementById("searchList").style.display = "block";
                    }
                }
    }, [activeSearch, results.length]);

    useEffect(() => { // Scroll to focused item
        if (focusedIndex >= 0) {
            document.querySelector(`.list-item.focused`).scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
            });
        }
    }, [focusedIndex]);

    const handleKeyDown = (e) => { //handles arrow key navigation in search results
        e.stopPropagation();
        if (results.length > 0 && (e.key === "ArrowDown" || e.key === "ArrowUp" || e.key === "Enter")) {
            if (e.key === "ArrowDown" && focusedIndex+1 <= Math.min (results.length - 1, MAX_RESULTS - 1)) {
                e.preventDefault(); // Prevent page scrolling
                setFocusedIndex(focusedIndex => focusedIndex + 1);
                setInput(results[focusedIndex+1].city_name);
            } else if (e.key === "ArrowUp" && focusedIndex > 0) {
                e.preventDefault(); // Prevent page scrolling
                setFocusedIndex(focusedIndex => Math.max(focusedIndex - 1, -1));
                setInput(results[Math.max(focusedIndex-1, -1)].city_name);
            } else if (e.key === "Enter" && focusedIndex >= 0) {
                e.preventDefault()
                setInput(results[focusedIndex].city_name);
                window.location.href = `${CITY_DETAIL_ENDPOINT}${results[focusedIndex].city_id}`;
                setFocusedIndex(-1); // Reset focus
            }
        }
    };    

    const handleSubmit = async (event) => { //handles form submission
        event.preventDefault();
    };

    return (
        <div>
            <div className="search-container mr-5">
                <Form onSubmit={handleSubmit} className="search-form">
                    <input
                        type="search"
                        placeholder="Enter a city name..."
                        value={input}
                        onChange={handleChange}
                        onKeyDown={handleKeyDown}
                        className="search-input"
                        spellCheck="false"
                        autoComplete="off"
                        onBlur={() => setActiveSearch(false)}
                        onFocus={() => setActiveSearch(true)}
                    />
                     <i className="mdi mdi-magnify" style={{position: 'absolute', top: '50%', right: '5%', transform: 'translateY(-50%)', fontSize: '24px'}}></i>
                </Form>
            </div>
            {input && results.length === 0 && (
                <ul className="search-results">
                <li className="p-2">No results</li>
                </ul>
            )}
            {input && (
                <ul className="search-results" id="searchList">
                    {results.slice(0, MAX_RESULTS).map((result, index) => (
                        <li key={index} className={`list-item ${index === focusedIndex ? 'focused' : ''}`} onClick={() => setInput(result.city_name)}>
                            <a href={`${CITY_DETAIL_ENDPOINT}${result.city_id}`}>{result.city_name}</a>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default Search;